// css
import "../../scss/pages/single-lifejournal.scss";

// utils
import foundation from "../_utils/foundation";
foundation();

// npm
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// libs
import HeaderSideNav from "../_libs/HeaderSideNav";
import AnchorScroll from "../_libs/AnchorScroll";
import SNSShare from "../_libs/SNSShare";
import ScrollObserver from "../_libs/ScrollObserver";
import Ranking from "../_libs/Ranking";

document.addEventListener("DOMContentLoaded", () => {
	HeaderSideNav();

	setTimeout(function () {
		document.querySelectorAll(".js-first-animation").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 200);

	setTimeout(function () {
		document.querySelectorAll(".js-fv").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 200);

	setTimeout(function () {
		const posts = document.querySelector(".js-post");
		const postImageSp = posts.querySelector(".js-post-image-sp");
		const postImagePc = document.querySelector(".js-post-image-pc");
		const tl = gsap.timeline();

		tl.to([posts, postImagePc], {
			opacity: 1,
			duration: 2,
			ease: "power2.out",
		})
			.to(
				postImageSp,
				{
					filter: "saturate(1)",
					duration: 1,
					ease: "power2.out",
				},
				"-=0.5"
			)
			.to(
				postImagePc,
				{
					filter: "saturate(1)",
					duration: 1,
					ease: "power3.out",
				},
				"<"
			);
	}, 400);

	SNSShare();
	Ranking();

	const scrollObserver_block = new ScrollObserver({
		target: ".js-block-target",
		addClass: "is-active",
		once: true,
		option: {
			rootMargin: "0px 0px -30% 0px",
		},
	});
	// 監視開始;
	scrollObserver_block.init();

	const rankingPosts = document.querySelectorAll(".js-ranking-post");
	gsap.to(rankingPosts, {
		opacity: 1,
		duration: 1.8,
		stagger: 0.25,
		ease: "power2.out",
		scrollTrigger: {
			trigger: ".js-ranking-post-trigger",
			start: "top 90%",
			toggleActions: "play none none none",
		},
	});

	// アンカースクロール
	let margnEle = 32;
	if (window.matchMedia("(min-width: 768px)").matches) {
		margnEle = 64;
	}
	AnchorScroll(".js-anchor-scroll", margnEle);
});
window.addEventListener("load", () => {});
